import {useEffect, useState} from "react";

export function useRPMFrame(subdomain, apiKey) {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState("");

  useEffect(() => {
    const iframe = document.getElementById("rpm-frame");

    iframe.src = `https://${subdomain}.readyplayer.me/avatar?frameApi&apiKey=${apiKey}`;

    const handleMessage = (event) => {
      if (!event.origin.includes("readyplayer.me")) return;

      let json;
      try {
        json = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      } catch {
        console.error("Fehler beim Parsen der Event-Daten");
        return;
      }

      if (!json || json.source !== "readyplayerme") return;

      switch (json.eventName) {
        case "v1.frame.ready":
          setIframeLoaded(true);
          iframe.contentWindow.postMessage(
            JSON.stringify({
              target: "readyplayerme",
              type: "subscribe",
              eventName: "v1.**",
            }),
            `https://${subdomain}.readyplayer.me`
          );
          break;
        case "v1.avatar.exported":
          if (json.data?.url) {
            setAvatarUrl(json.data.url);
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [subdomain, apiKey]);

  return { iframeLoaded, avatarUrl };
}